import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const VISTAS_CONST = 'vistas';
export const vistas_api = `${baseUrl}/sistema/${VISTAS_CONST}`;

export const allVistasService = async (params) => {
  const res = await axios.get(vistas_api, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveVistasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${vistas_api}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(vistas_api, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneVistasService = async (id) => {
  const res = await axios.get(`${vistas_api}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteVistasService = async (id) => {
  const res = await axios.delete(`${vistas_api}/${id}`, {
    headers: token({}),
  });
  return res;
};
